export const PROCESS_WITHDRAWAL_START = 'PROCESS_WITHDRAWAL_START';
export const PROCESS_WITHDRAWAL_SUCCESS =
  'PROCESS_WITHDRAWAL_SUCCESS';
export const PROCESS_WITHDRAWAL_ERROR = 'PROCESS_WITHDRAWAL_ERROR';
